<template>
  <vx-card>
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button-group>
          <el-button
            size="small"
            type="primary"
            @click="() => $router.push('/exim/kontrak/tambah')"
            icon="el-icon-plus"
          >
            {{ $t("create") }}</el-button
          >
          <el-button
            type="primary"
            @click="goToEdit"
            icon="el-icon-edit"
            size="small"
          >
            {{ $t("edit") }}</el-button
          >
          <el-button
            size="small"
            type="primary"
            icon="el-icon-delete"
            @click="handleDelete"
          >
            {{ $t("delete") }}</el-button
          >
          <el-button
            size="small"
            type="primary"
            icon="el-icon-printer"
            @click="handleToOpenModalPrint"
          >
            {{ $t("Print") }}</el-button
          >
        </el-button-group>
      </template>
      <template v-slot:tools>
        <DatePickerBetween @changeDate="getData" ref="dataPicker" />
      </template>
    </vxe-toolbar>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane
        v-for="v in tabList"
        :key="v.key"
        :label="v.namaTab"
        :name="v.key"
      >
        <TableFull :tableConfig="tableConfig" :ref="v.key" />
      </el-tab-pane>
    </el-tabs>
    <vxe-modal
      width="50%"
      height="auto"
      v-model="modalToPrint"
      title="SELECT PRINT TYPE"
    >
      <el-button @click="handlePrint('excel')" type="primary" size="mini">
        EXCEL
      </el-button>
      <el-button @click="handlePrint('pdf')" type="primary" size="mini">
        PDF
      </el-button>
    </vxe-modal>
  </vx-card>
</template>

<script>
import TableFull from "../../components/general/TableFull.vue";
import DatePickerBetween from "../../components/general/DatePickerBetween.vue";

export default {
  components: {
    DatePickerBetween,
    TableFull,
  },
  data() {
    return {
      modalToPrint: false,
      activeTab: "tabData",
      tabList: [
        {
          key: "tabData",
          namaTab: "DATA",
        },
        {
          key: "tabBarangAsal",
          namaTab: "BARANG ASAL",
        },
        {
          key: "tabBarangHasil",
          namaTab: "BARANG HASIL",
        },
      ],
      tableConfigs: {
        tabData: {
          bodyOverflow: false,
          headerOverflow: false,
          checkbox: true,
          tableName: "tabData",
          select: false,
          tableHeight: 550,
          rowHeight: 35,
          tableData: [],
          size: "mini",
          column: [
            {
              field: "noReg",
              key: "noReg",
              title: this.$t("NO REG").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "noKontrak",
              key: "noKontrak",
              title: this.$t("NOMOR KONTRAK").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "tanggal",
              key: "tanggal",
              format: "date",
              title: this.$t("TANGGAL KONTRAK").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "namaTtd",
              key: "namaTtd",
              title: this.$t("NAMA TTD").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "jabatanTtd",
              key: "jabatanTtd",
              title: this.$t("Jabatan").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "namaSubkontrak",
              key: "namaSubkontrak",
              title: this.$t("NAMA SUBKONTRAK").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "jabatanSubkontrak",
              key: "jabatanSubkontrak",
              title: this.$t("JABATAN").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "perusahaanSubkontrak",
              key: "perusahaanSubkontrak",
              title: this.$t("PERSH. SUBKONTRAK").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "alamatSubkontrak",
              key: "alamatSubkontrak",
              title: this.$t("ALAMAT").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "jenisPekerjaan",
              key: "jenisPekerjaan",
              title: this.$t("JENIS PEKERJAAN").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "currency",
              key: "currency",
              title: this.$t("CURRENCY").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "kurs",
              key: "kurs",
              title: this.$t("KURS").toUpperCase(),
              width: 150,
              align: "center",
            },
            {
              field: "remark",
              key: "remark",
              title: this.$t("REMARK").toUpperCase(),
              width: 150,
              align: "center",
            },
          ],
        },
        tabBarangAsal: {
          bodyOverflow: false,
          headerOverflow: false,
          checkbox: true,
          tableName: "tabBarangAsal",
          select: false,
          tableHeight: 550,
          rowHeight: 35,
          tableData: [],
          size: "mini",
          column: [
            {
              field: "kodeBarang",
              key: "kodeBarang",
              title: "KODE BARANG",
              width: 180,
              align: "center",
            },
            {
              field: "namaBarang",
              key: "namaBarang",
              title: "NAMA BARANG",
              width: 180,
              align: "center",
            },
            {
              field: "satuan",
              key: "satuan",
              title: "SATUAN",
              width: 180,
              align: "center",
            },
            {
              field: "hsCode",
              key: "hsCode",
              title: "HSCODE",
              width: 180,
              align: "center",
            },
            {
              field: "qty",
              key: "qty",
              title: "QTY",
              width: 180,
              align: "center",
            },
            {
              field: "currency",
              key: "currency",
              title: "CURRENCY",
              width: 180,
              align: "center",
            },
            {
              field: "kurs",
              key: "kurs",
              title: "KURS",
              width: 180,
              align: "center",
            },
            {
              field: "harga",
              key: "harga",
              title: "CNF",
              width: 180,
              align: "center",
            },
            {
              field: "amount",
              key: "amount",
              title: "CIF",
              width: 180,
              align: "center",
            },
            {
              field: "amountIdr",
              key: "amountIdr",
              title: "CIF RP",
              width: 180,
              align: "center",
            },
            {
              field: "exbcDokumen",
              key: "exbcDokumen",
              title: "EXBC DOKUMEN",
              width: 180,
              align: "center",
            },
          ],
        },
        tabBarangHasil: {
          bodyOverflow: false,
          headerOverflow: false,
          checkbox: true,
          tableName: "tabBarangHasil",
          select: false,
          tableHeight: 550,
          rowHeight: 35,
          tableData: [],
          size: "mini",
          column: [
            {
              field: "kodeBarang",
              key: "kodeBarang",
              title: "KODE BARANG",
              width: 180,
              align: "center",
            },
            {
              field: "namaBarang",
              key: "namaBarang",
              title: "NAMA BARANG",
              width: 180,
              align: "center",
            },
            {
              field: "satuan",
              key: "satuan",
              title: "SATUAN",
              width: 180,
              align: "center",
            },
            {
              field: "hsCode",
              key: "hsCode",
              title: "HSCODE",
              width: 180,
              align: "center",
            },
            {
              field: "qty",
              key: "qty",
              title: "QTY",
              width: 180,
              align: "center",
            },
          ],
        },
      },
      tableConfig: {},
    };
  },

  methods: {
    async getData(datas = { tglAwal: new Date(), tglAkhir: new Date() }) {
      let dateStart = this.$$formatDatemomentInput(datas.tglAwal);
      let dateEnd = this.$$formatDatemomentInput(datas.tglAkhir);
      this.tableData = [];

      const response = await this.$api.get(`api/v1/exim/subkon/findbydate`, {
        params: {
          start: dateStart,
          end: dateEnd,
          jenis: "MASUK",
        },
      });
      let asal = [];
      let hasil = [];
      response.data.content.forEach((elm) => {
        if (elm.listAsal) {
          asal = [...asal, ...elm.listAsal];
        }
        if (elm.listDetail) {
          hasil = [...hasil, ...elm.listDetail];
        }
      });
      this.tableConfigs.tabData.tableData = response.data.content;
      this.tableConfigs.tabBarangAsal.tableData = asal;
      this.tableConfigs.tabBarangHasil.tableData = hasil;
    },
    handleToOpenModalPrint() {
      if (this.$refs[this.activeTab][0].selectedCheckbox().length == 0) {
        this.$vs.notify({
          title: "PERHATIAN",
          text: "Pilih data yang akan di cetak terlebih dahulu",
          color: "warning",
        });
        return;
      }

      if (this.$refs[this.activeTab][0].selectedCheckbox().length > 1) {
        this.$vs.notify({
          title: "PERHATIAN",
          text: "Pilih hanya 1 data yang akan di cetak terlebih dahulu",
          color: "warning",
        });
        return;
      }

      this.modalToPrint = true;
    },
    handleDelete() {
      if (this.$refs[this.activeTab][0].selectedCheckbox().length == 0) {
        this.$vs.notify({
          title: "PERHATIAN",
          text: "Pilih data yang akan di hapus terlebih dahulu",
          color: "warning",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Konfirmasi",
        text: "Apakah anda yakin ingin menghapus data ini?",
        accept: this.acceptDelete,
        acceptText: "OK",
        acceptColor: "danger",
        cancelText: "Batal",
      });
    },

    async acceptDelete() {
      try {
        let datas = this.$refs[this.activeTab][0].selectedCheckbox();

        for (const data of datas) {
          console.log(data);

          await this.$api.post(`api/v1/exim/subkon/deleteall`, [data]);
        }

        this.$vs.notify({
          title: "BERHASIL",
          text: "Data Berhasil Dihapus",
          color: "success",
        });

        this.getData();
      } catch (error) {
        console.log(error);
      }
    },
    goToEdit() {
      if (this.$refs[this.activeTab][0].selectedCheckbox().length == 0) {
        this.$vs.notify({
          title: "PERHATIAN",
          text: "Pilih data yang akan diedit terlebih dahulu",
          color: "warning",
        });
        return;
      }

      if (this.$refs[this.activeTab][0].selectedCheckbox().length > 1) {
        this.$vs.notify({
          title: "PERHATIAN",
          text: "Pilih hanya 1 data yang akan diedit terlebih dahulu",
          color: "warning",
        });
        return;
      }

      this.$router.push({
        path: "/exim/kontrak/edit",
        query: {
          selected: this.$refs[this.activeTab][0].selectedCheckbox()[0],
        },
      });
    },

    async handlePrint(type) {
      switch (type) {
        case "excel":
          try {
            const res = await this.$api.get(
              this.$serviceApi + `exim/printkontrak`,
              {
                params: {
                  noReg:
                    this.$refs[this.activeTab][0].selectedCheckbox()[0].noReg,
                  type: type,
                },
                responseType: "blob",
              }
            );
            const contentType = res.headers["content-type"];

            let blob = new Blob([res.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "contract.xlsx";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          } catch (error) {
            console.log(error);
          }
          break;

        case "pdf":
          try {
            const res = await this.$api.get(
              this.$serviceApi + `exim/printkontrak`,
              {
                params: {
                  noReg:
                    this.$refs[this.activeTab][0].selectedCheckbox()[0].noReg,
                  type: type,
                },
                responseType: "blob",
              }
            );

            if (res && res.data) {
              let blob = new Blob([res.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              window.open(url, "_blank");
            } else {
              console.error("No data received for the PDF");
            }
          } catch (error) {
            console.error("Error during PDF generation:", error);
          }
          break;
      }
    },
    changeTab(tab) {
      this.activeTab = tab.name;
      this.tableConfig = this.tableConfigs[this.activeTab];
    },
  },
  mounted() {
    this.tableConfig = this.tableConfigs[this.activeTab];
  },
};
</script>
